var cibTensorflow = ["32 32", "<path d='M26.135 16l0.13 6.266-4.13-2.401v8.938l-5.469 3.198v-32l13.599 7.865v7.068l-8.13-4.797v3.599zM1.734 7.865l13.599-7.865v32l-5.469-3.198v-18.667l-8.13 4.797z'/>"];

export { cibTensorflow };
//# sourceMappingURL=cib-tensorflow.js.map
